import { InjectionToken, Provider } from '@angular/core';
import { environment } from '@environments/environment';
import { MroManualRepository } from '../mro-manual.repository';
import { MroManualApiService } from '../mro-manual-api.service';
import { MroManualApiServiceMock } from '@mocks/mro-manual-api-mock.service';

export const HTTP_MRO_MANUAL_SERVICE = new InjectionToken<MroManualRepository>('MroManualRepository');

export const MRO_MANUAL_API_PROVIDER: Provider = {
    provide: HTTP_MRO_MANUAL_SERVICE,
    useClass: environment.useMocks && environment.useMocks.mroManual ? MroManualApiServiceMock : MroManualApiService,
};
